import { Group, Pagination, Skeleton, Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useAlbums } from '~/api/queries'
import { AlbumGrid } from '~/components/blocks/AlbumGrid/AlbumGrid'

export const Route = createFileRoute('/_app/most-played/')({
  component: MostPlayedPage,
})

function MostPlayedPage() {
  const [page, setPage] = useState(1)
  const limit = 30
  const { data, isLoading } = useAlbums({ sort: 'frequent', limit, offset: (page - 1) * limit })

  const totalPages = data ? Math.ceil(data.total / limit) : 0

  return (
    <Stack gap="md">
      <Title order={2}>Most Played</Title>

      {isLoading ? <Skeleton h={400} /> : data?.data ? <AlbumGrid albums={data.data} /> : null}

      {totalPages > 1 && (
        <Group justify="center">
          <Pagination value={page} onChange={setPage} total={totalPages} />
        </Group>
      )}
    </Stack>
  )
}
